/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable object-curly-newline */
import React from 'react';
import {
    string, shape, arrayOf, bool,
} from 'prop-types';

import Divider from '@material-ui/core/Divider';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import ShippingAddress from './ItemDetail/ShippingAddress';
import DeliveryDate from './ItemDetail/DeliveryDate';
import OrderTracking from './ItemDetail/OrderTracking';
import GiftMessage from './ItemDetail/GiftMessage';
import ProductDetails from './ItemDetail/ProductDetails';
import ModifyOrder from './MMO/ModifyOrder';
import OrderListItem from '../TrackOrder/OrderListItem';

class ItemDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mmoOpen: false,
            mmoAction: '',
            itemDetailListState: [],
            orderData: {
                inOrderId: '',
                brandOrderNum: '',
                intOrderNumber: '',
            },
        };
    }

    componentDidMount() {
        const closeEditIframe = (event) => {
            if (event.data === 'close') {
                this.setState({ mmoOpen: false });
            }
        };
        if (window.addEventListener) {
            window.addEventListener('message', closeEditIframe, false);
        } else {
            window.attachEvent('onmessage', closeEditIframe);
        }
    }

    componentWillUnmount() {
        const closeEditIframe = (event) => {
            if (event.data === 'close') {
                this.setState({ mmoOpen: false });
            }
        };
        if (window.addEventListener) {
            window.removeEventListener('message', closeEditIframe, false);
        } else {
            window.detachEvent('onmessage', closeEditIframe);
        }
    }

    closeModifyOrder = () => {
        this.setState({ mmoOpen: false });
    }

    openModifyOrder = (action, item, orderData) => {
        this.setState({ mmoOpen: true, mmoAction: action, itemDetailListState: item, orderData });
    }

    fullTemplate = ({
        recipient,
        status,
        actualDeliveryDate,
        itemDetailList,
        trackingNumber,
        carrier,
        orderDate,
        inOrderId,
        brandOrderNum,
        intOrderNumber,
        orderNumberPure,
        mmo,
    }) => {
        const firstItemDetailList = itemDetailList[0];
        const { cardMessage, subscriptionType, cardMsgEnable } = firstItemDetailList;
        // I -> In transit
        // D/U -> Delivered
        // C -> Cancelled
        // W and all other status -> Order Received
        const validStatus = status || 'W';

        // console.log('itemDetailList', itemDetailList);

        const isPassport = subscriptionType === 'Passport';
        const { mmoOpen, closeModifyOrder, openModifyOrder, mmoAction, token, itemDetailListState, orderData } = mmo;

        return (
            <>
                {mmoOpen ? (
                    <ModifyOrder
                        action={mmoAction}
                        mmoOpen={mmoOpen}
                        orderId={orderNumberPure || orderData.inOrderId}
                        itemDetail={itemDetailListState}
                        closeMMO={closeModifyOrder}
                        token={token}
                        brandOrderNum={orderData.brandOrderNum}
                        intOrderNumber={orderData.intOrderNumber}
                    />
                ) : null}
                <ShippingAddress
                    openMmo={openModifyOrder}
                    recipient={recipient}
                    isPassport={isPassport}
                    itemDetailList={itemDetailList}
                    orderData={{  inOrderId, brandOrderNum, intOrderNumber }}
                />
                <Divider />
                <DeliveryDate
                    openMmo={openModifyOrder}
                    itemDetailList={itemDetailList}
                    orderData={{  inOrderId, brandOrderNum, intOrderNumber }}
                    data={{
                        status: validStatus,
                        actualDeliveryDate,
                        firstItemDetailList,
                        orderDate,
                        isPassport,
                    }}
                />
                <Divider />
                <OrderTracking
                    data={{ status: validStatus, trackingNumber, carrier, isPassport }}
                />
                <Divider />
                {!isPassport ? (
                    <>
                        <GiftMessage orderData={{  inOrderId, brandOrderNum, intOrderNumber }} itemDetailList={itemDetailList} openMmo={openModifyOrder} cardMessage={cardMessage} cardMsgEnable={cardMsgEnable} />
                        <Divider />
                    </>
                ) : (
                    ''
                )}
                <ProductDetails
                    itemDetailList={itemDetailList}
                    isPassport={isPassport}
                />
            </>
        );
    };

    listTemplate = () => {
        const { uuid, ItemDetail: items, userProfile } = this.props;
        if (!items.recpFirstName) {
            items.recpFirstName = items.recipientFirstName;
        }
        if (!items.recpLastName) items.recpLastName = items.recipientLastName;
        const order = {
            uuid,
            orderNumber: items.orderNumber,
            inOrderId: items.orderNumber,
            items: [{ ...items }],
            className: '',
        };
        return <OrderListItem order={order} userProfile={userProfile} className="" />;
    };

    render() {
        // console.log(this.props.ItemDetail, 'KEY PROPS');
        const { mmoOpen, mmoAction, itemDetailListState, orderData } = this.state;
        const { token } = this.props.ItemDetail; // eslint-disable-line react/destructuring-assignment
        const {
            ItemDetail: {
                status,
                paymentStatus,
                actualDeliveryDate,
                recipientDetail: recipient,
                itemDetailList,
                trackingNumber,
                carrier,
                orderDate,
                orderNumber,
                intOrderNumber,
                brandOrderNum,
                orderNumberPure,
            },
        } = this.props;
        if (itemDetailList.length < 1) return null;
        const fullTemplateData = {
            recipient,
            status: status || paymentStatus,
            actualDeliveryDate,
            itemDetailList,
            trackingNumber,
            carrier,
            intOrderNumber,
            brandOrderNum,
            orderDate,
            inOrderId: orderNumber,
            orderNumberPure,
            mmo: {
                mmoOpen,
                token,
                closeModifyOrder: this.closeModifyOrder,
                openModifyOrder: this.openModifyOrder,
                mmoAction: mmoAction || 'editMsg',
                itemDetailListState,
                orderData,
            },
        };

        return (
            <Card className="margin-top card-border-3 delivery-info">
                <CardContent>
                    {recipient
                        ? this.fullTemplate({ ...fullTemplateData })
                        : this.listTemplate()}
                </CardContent>
            </Card>
        );
    }
}

ItemDetail.defaultProps = {
    uuid: '',
};

ItemDetail.propTypes = {
    uuid: string,
    ItemDetail: shape({
        actualDeliveryDate: string,
        arrivalEndDate: string,
        arrivalStartDate: string,
        carrier: string,
        customerFirstName: string.isRequired,
        customerLastName: string.isRequired,
        deliverySignature: string,
        exceptionCode: string,
        exceptionDateTime: string,
        exceptionMessage: string,
        flexDate: string,
        flexGuaranteedFlag: string,
        flexMessage: string,
        intOrderNumber: string.isRequired,
        orderDate: string.isRequired,
        orderNumber: string.isRequired,
        orderNumberPure: string.isRequired,
        phoneNumber: string,
        recipientFirstName: string.isRequired,
        recipientLastName: string.isRequired,
        recipientZip: string.isRequired,
        requestedDeliveryDate: string,
        rescheduledDeliveryDate: string,
        resolutionDesc: string,
        shipDate: string,
        shipState: string.isRequired,
        shipmentCode: string,
        status: string.isRequired,
        trackingNumber: string,
        itemDetailList: arrayOf(
            shape({
                productName: string,
                productSku: string,
                productBrand: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                prdImgCtg: string,
                prdImgTmn: string,
                seoUrl: string,
            }),
        ),
        recpFirstName: string.isRequired,
        recpLastName: string.isRequired,
    }).isRequired,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
};

export default ItemDetail;
